import { render, staticRenderFns } from "./AllArticlesTab.vue?vue&type=template&id=3708b168"
import script from "./AllArticlesTab.vue?vue&type=script&lang=js"
export * from "./AllArticlesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports